import { CircularProgress } from '@material-ui/core';
import React from 'react';

const Loader = () : React.ReactElement => {
    return (
        <div className={'posa post0 posr0 posb0 posl0 aic jcc zi1000'}>
            <div className={'posa aic jcc h50 w50'}>
                <div className={'posa aic jcc'}>
                    <img height={40} src={`${ASSET_BASE}/assets/images/logo.png`} />
                </div>
                <CircularProgress color={'primary'} className={'posr post0 posr0 posb0 posl0'} size={50} />
            </div>
        </div>
    );
};

export default Loader;
